module.exports = __webpack_public_path__ + "static/media/list-excel.ab607916.svg";